import { motion } from 'framer-motion';
import { Eyebrow, MaskedLines, EASE } from './bits';

export default function PageHero({ eyebrow, lines, sub, img, alt, children, tall = false }) {
  return (
    <section className={`relative flex items-end overflow-hidden bg-ink ${tall ? 'min-h-[88svh]' : 'min-h-[62svh]'}`}>
      <motion.img
        src={img}
        alt={alt}
        initial={{ scale: 1.08, opacity: 0.6 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.6, ease: EASE }}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/30" aria-hidden="true" />
      <div className="relative mx-auto w-full max-w-7xl px-6 pb-16 pt-44 sm:px-12 lg:px-20">
        <Eyebrow dark>{eyebrow}</Eyebrow>
        <MaskedLines
          as="h1"
          lines={lines}
          delay={0.15}
          className="mt-6 font-display text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl"
        />
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6, ease: EASE }}
            className="mt-6 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg"
          >
            {sub}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.75, duration: 0.6, ease: EASE }}
            className="mt-8 flex flex-wrap gap-4"
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
